module.exports = __webpack_public_path__ + "static/media/three-modes.cf992d17.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep3/three-modes.png
 ** module id = 222
 ** module chunks = 0
 **/